
import { queryify } from '@bingads-webui/url-util';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';

export const getProductData = (cid, aid, uid) => {
  const url = queryify('/Campaign/NewCampaign/GetProductScope', {
    aid,
    cid,
    uid,
  });

  const params = {
    url,
    adapter: 'legacy',
    bypassCache: false,
    cacheResponse: true,
  };

  return jsData.Product.find('MetaData', params);
};
